export const AllIncidentsByLocation=(id)=>{
        return $.get('api/Incident/GetAllIncidents?LocationId='+id)
}
export const AllDailyLogs=(IsActive,skip,take,locationId)=>{
        return $.get('LogTemplate/GetDashboardLogTemplateEntries?IsActive=true&skip=null&take=null&locationId='+locationId)
}
export const GetAllActivity = (LocationId) => {
        return $.get('Patron/GetAllActivity?LocationId='+LocationId)    
    }
export const GetActivityCalendar = (locationId,poolId) => {
        return $.get('Patron/GetActivityCalendar?locationId='+locationId+'&poolId='+poolId)
}
/*
export const AllDailyLogs=(IsActive,skip,take,locationId)=>{
  return $.get('LogTemplate/GetDashboardLogTemplateEntries?IsActive=true&skip=null&take=null&locationId='+locationId)
}
*/



// WEBPACK FOOTER //
// ./src/pages/Dashboard/dashboard.services.js